import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card } from './ui/card';

const Testimonials = () => {
  const testimonials = [
    {
      name: 'Sarah Mitchell',
      role: 'Competitive Skater',
      content: 'Hristina has transformed my skating completely. Her technical expertise and artistic guidance helped me achieve my best competition results ever. She knows exactly how to bring out the best in each skater.',
      rating: 5
    },
    {
      name: 'David Chen',
      role: 'Parent',
      content: 'We are so grateful to have found Coach Hristina. Her patience and dedication to my daughter\'s development have been incredible. She combines discipline with encouragement perfectly.',
      rating: 5
    },
    {
      name: 'Emma Rodriguez',
      role: 'Adult Skater',
      content: 'As an adult returning to skating, I was nervous, but Hristina made me feel confident and capable. Her coaching style is both professional and warm. Highly recommend!',
      rating: 5
    }
  ];

  return (
    <section id="testimonials" className="py-24 bg-slate-900">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-block px-4 py-2 bg-amber-600 text-white rounded-full text-sm font-semibold mb-6">
            Testimonials
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            What Skaters Say
          </h2>
          <p className="text-xl text-slate-300">
            Hear from students and families who have experienced the transformative power of expert coaching.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <Card
              key={index}
              className="p-8 bg-slate-800 border-slate-700 hover:border-amber-400 hover:shadow-xl transition-all duration-300 relative"
            >
              {/* Quote Icon */}
              <div className="absolute -top-4 -left-4 bg-amber-600 w-12 h-12 rounded-full flex items-center justify-center shadow-lg">
                <Quote className="w-6 h-6 text-white" />
              </div>

              {/* Stars */}
              <div className="flex space-x-1 mb-6">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-amber-400 text-amber-400" />
                ))}
              </div>

              {/* Content */}
              <p className="text-slate-300 leading-relaxed mb-6">
                "{testimonial.content}"
              </p>

              {/* Author */}
              <div className="border-t border-slate-700 pt-6">
                <div className="font-bold text-white">
                  {testimonial.name}
                </div>
                <div className="text-sm text-slate-400">
                  {testimonial.role}
                </div>
              </div>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-slate-300 mb-6 text-lg">
            Ready to start your journey? Join our community of dedicated skaters.
          </p>
          <button
            onClick={() => document.getElementById('contact').scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center px-8 py-4 bg-sky-600 hover:bg-sky-700 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-all duration-300"
          >
            Get in Touch
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;